import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { getEmailCaps } from "@/lib/emailCaps";

// Preview only: reminds that no real email leaves the app
export const SimulationBanner = () => {
  const [sim, setSim] = useState(false);
  useEffect(() => { getEmailCaps().then((c) => setSim(!!c.simulation)); }, []);
  if (!sim) return null;
  return (
    <div className="bg-slate-800 text-slate-100 text-[11px] py-1 px-4 flex items-center justify-center gap-1.5" data-testid="email-simulation-banner">
      <FlaskConical className="w-3 h-3" /> Envois simulés : aucun e-mail ne part depuis cet aperçu
    </div>
  );
};
